import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { SubOptionListComponent } from 'ui-components';
import { getMultiTermText } from '../../../../utils/commonUtils';

interface ITableOptions {
    onClickEdit: () => void;
    onClickTrialPeriods: () => void
}

const ProductionSitesTableOptions = ({ onClickEdit, onClickTrialPeriods }: ITableOptions) => {
    const optionList = {
        list: [
            {
                title: getMultiTermText({ text: 'Edit', id: '99006184' }),
                click: onClickEdit,
                key: 'edit'
            },
            {
                title: getMultiTermText({ text: 'Trial periods', id: '99032446' }),
                click: onClickTrialPeriods,
                key: 'trialPeriods'
            }
        ]
    };
    return <SubOptionListComponent optionList={optionList} />;
};

export default ProductionSitesTableOptions;
